module.exports = __webpack_public_path__ + "static/img/homeright2.3ef3f3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeright2.png
// module id = joWC
// module chunks = 13